(() => {
  const photoOrigin = 'https://fabrikone-studyom.fabrikone-apps.workers.dev';
  const element = (tag, text, className) => { const node = document.createElement(tag); if (text != null) node.textContent = text; if (className) node.className = className; return node; };
  const format = (template, key, value) => template.replaceAll('{' + key + '}', String(value));
  function init(root) {
    if (root.dataset.reviewBound) return;
    root.dataset.reviewBound = 'true';
    const messages = JSON.parse(root.querySelector('[data-review-messages]').textContent);
    const form = root.querySelector('[data-fab-review-api]'), submit = form.querySelector('[data-fab-review-submit]');
    const result = form.querySelector('[data-review-result]'), name = form.querySelector('[data-fab-review-name]');
    const publicName = form.querySelector('[data-fab-review-public-name]'), preview = form.querySelector('[data-fab-review-name-preview]');
    const grid = root.querySelector('[data-review-list]'), summary = root.querySelector('[data-review-summary]');
    const loadStatus = root.querySelector('[data-review-load-status]'), retry = root.querySelector('[data-review-retry]'), more = root.querySelector('[data-review-more]');
    const endpoint = new URL(root.dataset.reviewEndpoint, location.origin); endpoint.searchParams.set('product', root.dataset.reviewProduct);
    let token = '', requestId = crypto.randomUUID(), next = null, loading = false, current = 0;
    const visibleName = () => {
      const value = name.value.normalize('NFC').trim().replace(/\s+/gu, ' ');
      const visible = form.querySelector('[data-fab-review-visibility] input:checked')?.value === 'Açık';
      const text = visible ? value : value.split(' ').filter(Boolean).map(p => Array.from(p)[0].toLocaleUpperCase('tr-TR') + '*'.repeat(Math.max(0, Array.from(p).length - 1))).join(' ');
      publicName.value = text; preview.textContent = text || preview.dataset.emptyText;
      name.setCustomValidity(value ? '' : name.dataset.requiredText);
      return visible;
    };
    async function api(url, options = {}) {
      const response = await fetch(url, { credentials:'same-origin', cache:'no-store', redirect:'error', signal:AbortSignal.timeout(45000), ...options });
      let value; try { value = await response.json(); } catch { throw new Error('CONNECTION'); }
      if (!response.ok || value.error) throw new Error(value.error || 'CONNECTION');
      return value;
    }
    function stars(score) {
      const node = element('div', '★'.repeat(score) + '☆'.repeat(5-score), 'fab-review-card__stars');
      node.setAttribute('aria-label', format(messages.rating, 'rating', score)); return node;
    }
    function card(review) {
      const article = element('article'); article.append(stars(review.rating));
      if (review.title) article.append(element('h3', review.title));
      if (review.body) article.append(element('p', review.body));
      if (review.photos?.length) {
        const gallery = element('div', null, 'fab-review-gallery');
        review.photos.forEach(path => {
          if (!/^\/review-image\/r-[a-f0-9]{64}\/[0-2]$/.test(path)) return;
          const link = element('a'), img = element('img'); link.href = photoOrigin + path; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.setAttribute('aria-label', messages.photo);
          img.src = link.href; img.alt = messages.photo; img.width = 90; img.height = 90; img.loading = 'lazy'; link.append(img); gallery.append(link);
        });
        article.append(gallery);
      }
      const footer = element('footer'); footer.append(element('strong', review.name));
      if (/^\d{4}-\d{2}-\d{2}$/.test(review.date)) { const time = element('time', new Intl.DateTimeFormat(document.documentElement.lang || 'tr').format(new Date(review.date + 'T12:00:00Z'))); time.dateTime = review.date; footer.append(time); }
      if (review.verified) footer.append(element('span', messages.verified));
      article.append(footer); return article;
    }
    function renderSummary(data) {
      summary.replaceChildren();
      const link = document.querySelector('[data-fab-review-link]');
      if (link) {
        link.setAttribute('aria-label', messages.readReviews);
        link.querySelectorAll('.fab-rating-summary__score,.fab-rating-summary__count,.fab-rating-summary__separator').forEach(n => n.remove());
        link.querySelector('.fab-rating-summary__stars')?.style.setProperty('--fab-rating-fill', (data.average * 20) + '%');
      }
      if (!data.count) return;
      const average = new Intl.NumberFormat(document.documentElement.lang || 'tr', { maximumFractionDigits:1 }).format(data.average);
      summary.append(element('strong', average + ' / 5'), element('span', format(messages.count, 'count', data.count)));
      if (link) {
        link.prepend(element('strong', average, 'fab-rating-summary__score'));
        link.append(element('span', '·', 'fab-rating-summary__separator'), element('span', format(messages.count, 'count', data.count), 'fab-rating-summary__count'));
        if (Number.isInteger(data.comments)) link.append(element('span', format(messages.comments, 'count', data.comments), 'fab-rating-summary__count'));
        link.setAttribute('aria-label', format(messages.rating, 'rating', average) + ', ' + format(messages.count, 'count', data.count));
      }
    }
    async function load(append = false) {
      if (loading) return; loading = true; more.disabled = true; retry.disabled = true;
      try {
        const url = new URL(endpoint); if (append && next !== null) url.searchParams.set('offset', String(next));
        const data = await api(url); token = data.token;
        if (!Array.isArray(data.reviews)) throw new Error('CONNECTION');
        if (!append) { grid.replaceChildren(); current = 0; renderSummary(data); }
        for (const review of data.reviews) { grid.append(card(review)); current++; }
        next = data.next; more.hidden = next === null; loadStatus.hidden = true; retry.hidden = true;
      } catch { loadStatus.textContent = messages.loadFailed; loadStatus.hidden = false; retry.hidden = false; }
      finally { loading = false; more.disabled = false; retry.disabled = false; }
    }
    retry.addEventListener('click', () => load()); more.addEventListener('click', () => load(true));
    function changed() { visibleName(); if (form.dataset.submitting !== 'true') { requestId = crypto.randomUUID(); result.textContent = ''; result.classList.remove('is-error'); } }
    form.addEventListener('input', changed); form.addEventListener('change', changed);
    form.addEventListener('submit', async event => {
      event.preventDefault(); event.stopImmediatePropagation();
      if (form.dataset.submitting === 'true' || form.fabReviewPhotos?.busy) return;
      const showName = visibleName(); if (!form.reportValidity()) return;
      const values = new FormData(form), disabled = [];
      form.dataset.submitting = 'true'; submit.disabled = true; result.textContent = messages.saving; result.classList.remove('is-error');
      const originalLabel = submit.textContent; submit.textContent = messages.saving;
      form.querySelectorAll('input,textarea,button').forEach(control => { if (!control.disabled) { control.disabled = true; disabled.push(control); } });
      try {
        if (!token) token = (await api(endpoint)).token;
        const photos = await form.fabReviewPhotos?.upload() || [];
        const body = { requestId, name:name.value, showName, email:values.get('contact[email]'), rating:Number(values.get('contact[Puan]')), title:values.get('contact[Yorum başlığı]') || '', body:values.get('contact[Yorum]') || '', consent:values.get('contact[KVKK onayı]') === 'Onaylandı', website:values.get('website') || '', photos };
        const send = () => api(endpoint, { method:'POST', headers:{'Content-Type':'application/json','X-Fabrikone-Review-Token':token}, body:JSON.stringify(body) });
        let data; try { data = await send(); } catch (error) { if (error.message !== 'REVIEW_TOKEN_EXPIRED') throw error; token = (await api(endpoint)).token; data = await send(); }
        if (data.saved !== true) throw new Error('CONNECTION');
        form.reset(); requestId = crypto.randomUUID(); visibleName(); result.textContent = messages.success; result.focus();
      } catch (error) {
        result.textContent = error.message === 'TOO_MANY_REVIEWS' ? messages.tooMany : messages.failed;
        result.classList.add('is-error'); result.focus();
      } finally {
        form.dataset.submitting = 'false'; disabled.forEach(control => { control.disabled = false; }); submit.disabled = false; submit.textContent = originalLabel;
      }
    }, true);
    visibleName(); submit.disabled = false; load();
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && form.dataset.submitting !== 'true') load(); });
  }
  const start = () => document.querySelectorAll('[data-fab-native-reviews][data-review-endpoint]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', start);
})();
